import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Image } from "react-bootstrap";
import Header from "../../../layouts/Header";
import { europeanFormatWithSymbol } from "../../../utils/European-Format/NumberFormatter";
import plusBorderWhite from "../../../assets/icons/Plus-border-white.svg";
import Package from "../../../assets/icons/package.svg";
import "../../../assets/styles/local/AddPurchasingOrder.css";
import "../../../assets/styles/local/ConfirmPurchasingOrder.css";
import "../../../assets/styles/local/ViewPurchasingOrder.css";
import CheckboxIcon from "../../../assets/images/CheckboxWhite.svg";
import CheckboxBlueIcon from "../../../assets/images/CheckboxBlue.svg";
import Xicon from "../../../assets/icons/Xicon.svg";
import EquipmentsPartsModal from "./EquipmentsPartsModal";
import {
  AddAssetPurchasingOrder,
  FetchLastPurchasingOrderCode,
  FetchSuppliers,
  FetchAssetPurchasingOrderByID,
} from "../../../redux/actions/action";
import delete1 from "../../../assets/images/delete.svg";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { ROLES } from "../../../utils/helpers/userRole";

const ViewPurchasingOrderAssets = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [assetList, setAssetList] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [poId, setPoId] = useState("");
  const [supplierToggle, setSupplierToggle] = useState(false);
  const [toggleActive, setToggleActive] = useState(true);
  const [assetToggle, setAssetToggle] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState([]);
  const [selectedSupplierData, setSelectedSupplierData] = useState([]);
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);

  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  const fetchAssetPurchasingOrderByIdRes = useSelector(
    (state) => state.user.fetchAssetPurchasingOrderByIdRes,
  );

  const location = useLocation();
  const locationState = location.state;
  const assetName = location?.state?.assetName;
  const assetId = window.localStorage.getItem("assetId");
  const assetList_AssetId = window.localStorage.getItem("assetList_AssetId");
  const roleAccess = window.localStorage.getItem("roleid");

  const currentAsset = localStorage.getItem("currentAsset");
  const parsedAsset = JSON.parse(currentAsset);
  const currentAsset2 = {
    currentAssetName: parsedAsset?.assetName,
    currentAssetID: parsedAsset?.assetId,
  };

  const [locationAssetName, setLocationAssetName] = useState("");
  const [locationAssetID, setLocationAssetID] = useState("");

  const [locationSupplierName, setLocationSupplierName] = useState("");
  const [locationSupplierID, setLocationSupplierID] = useState("");

  const [locationPurchasingOrderID, setLocationPurchasingOrderID] =
    useState("");

  useEffect(() => {
    if (locationState?.from === "Asset_List_Screen") {
      // console.log("asc45",locationState)
      setLocationAssetName(locationState?.history_AssetName);
      setLocationAssetID(locationState?.history_AssetID);
    }

    // if (locationState?.from === "Asset_Purchasing_Screen") {
    //   console.log("asc456",locationState)
    //   setLocationAssetName(locationState?.history_AssetName);
    //   setLocationAssetID(locationState?.history_AssetID);
    //   setLocationSupplierName(locationState?.history_SupplierName);
    //   setLocationSupplierID(locationState?.history_SupplierID);
    // }
  }, []);

  useEffect(() => {
    dispatch(
      FetchAssetPurchasingOrderByID(locationState?.history_PurchasingOrderID),
    );
  }, []);

  useEffect(() => {
    if (locationState?.from === "Asset_Purchasing_Screen") {
      // console.log("asc456", locationState);
      setLocationAssetName(locationState?.history_AssetName);
      setLocationAssetID(locationState?.history_AssetID);
      setLocationSupplierName(locationState?.history_SupplierName);
      setLocationSupplierID(locationState?.history_SupplierID);
      setLocationPurchasingOrderID(locationState?.history_PurchasingOrderID);

      if (fetchAssetPurchasingOrderByIdRes.status === true) {
        let data = [];
        fetchAssetPurchasingOrderByIdRes?.data[0]?.purchasingOrder?.map(
          (item) => {
            return data.push({
              internalId: item?.internalid,
              assetname: item?.productname,
              costPrice: item?.costprice,
              quantity: item?.quantity,
              total: Number(item?.total),
              requestedDeliverDays: item?.requestedDeliverDays,
              grandTotal: fetchAssetPurchasingOrderByIdRes?.data[0]?.total,
              assetid: fetchAssetPurchasingOrderByIdRes?.data[0]?.assetid,
            });
          },
        );
        setAssetList(data);
      }
    }
  }, [fetchAssetPurchasingOrderByIdRes]);

  useEffect(() => {
    if (assetId) {
      dispatch(FetchLastPurchasingOrderCode(assetId));
    }
  }, [dispatch, assetId]);

  useEffect(() => {
    dispatch(FetchSuppliers());
  }, [dispatch]);

  const fetchSuppliersProductList = useSelector(
    (state) => state.user.fetchSuppliersProduct,
  );

  useEffect(() => {
    if (fetchSuppliersProductList.status === true) {
      setSupplier(fetchSuppliersProductList?.data);
    }
  }, [fetchSuppliersProductList]);

  const FetchLastPurchasingOrderCodeList = useSelector(
    (state) => state.user.fetchLastPurchasingOrderCode,
  );

  useEffect(() => {
    if (FetchLastPurchasingOrderCodeList.status === true) {
      setPoId(FetchLastPurchasingOrderCodeList?.data);
    }
  }, [FetchLastPurchasingOrderCodeList]);

  const AddAssetPurchasingOrderRes = useSelector(
    (state) => state.user.addAssetPurchasingOrder,
  );

  useEffect(() => {
    if (AddAssetPurchasingOrderRes.status === true) {
      history.goBack();
      dispatch({ type: "ADD_ASSET_PURCHASING_ORDER", data: {} });
    }
  }, [AddAssetPurchasingOrderRes]);

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
    }
  }, [getAppSideNavOptions]);
  const handleCancel = () => {
    setAssetToggle(false);
  };

  const onSubmitPO = () => {
    const payload = {
      assetId: assetList_AssetId ? assetList_AssetId : locationAssetID,
      supplierId: selectedSupplier[0]?.supplierid
        ? selectedSupplier[0]?.supplierid
        : locationSupplierID,
      total: assetList.reduce((a, b) => (a = a + b.total), 0) ?? 0,
      purchasingOrder: assetList.map(
        ({ productid, quantity, total, requestedDeliverDays }) => ({
          productid,
          quantity,
          total,
          requestedDeliverDays,
        }),
      ),
    };
    dispatch(AddAssetPurchasingOrder(payload));
  };
  const onDelete = (index) => {
    const updatedAssetList = [...assetList];
    updatedAssetList.splice(index, 1);
    setAssetList(updatedAssetList);
  };

  const parseCurrency = (currencyString) => {
    // Assuming the currency format is '€ 2,00'
    const numericValue = parseFloat(
      currencyString?.replace(/[^\d.,]/g, "")?.replace(",", "."),
    );

    return isNaN(numericValue) ? 0 : numericValue;
  };

  const handleQuantityChange = (assetId, newQuantity) => {
    // Find the asset in the assetList
    const updatedAssetList = assetList.map((item) => {
      if (item.assetid === assetId) {
        // Convert the costPrice to a numeric value
        const costPriceNumeric = parseCurrency(item.costPrice);

        // Calculate the new total based on the new quantity and costPrice
        const newTotal = newQuantity * costPriceNumeric;

        // Update the item with the new quantity and total
        return {
          ...item,
          quantity: newQuantity,
          total: newTotal,
        };
      }
      return item;
    });

    // Update the assetList with the modified asset
    setAssetList(updatedAssetList);
  };
  const handleDaysChange = (assetId, newQuantity) => {
    const updatedAssetList = assetList.map((item) => {
      if (item.assetid === assetId) {
        return {
          ...item,
          requestedDeliverDays: newQuantity,
        };
      }
      return item;
    });

    // Update the assetList with the modified asset
    setAssetList(updatedAssetList);
  };
  return (
    <div className="container-fluid main-wrapper mb-4">
      <div className="containerBox">
        <div className="stock-heading-box">
          <div
            className="stock-heading cursor-pointer"
            onClick={() => {
              history.push("/asset-management");
            }}
          >
            Assets
          </div>
          <div className="confirm-box-title">
            <div className="opacity-1"> Purchasing Order</div>
            <div className="stock-order-id">ID {poId}</div>
          </div>
        </div>
        <Header />
      </div>
      <div className="d-flex align-items-center justify-content-end">
        <button
          type="button"
          className="btn addParchCancel me-4"
          onClick={() => {
            history.goBack();
          }}
        >
          Cancel
        </button>
        {roleAccess !== ROLES.VIEWER && roleAccess !== ROLES.USER && (
          <button
            onClick={onSubmitPO}
            type="button"
            className="btn addParchAdd"
            disabled={
              !selectedSupplier[0]?.supplierid ||
              locationState?.from === "Asset_Purchasing_Screen"
            }
          >
            Add
          </button>
        )}
      </div>
      <div
        className={
          locationState?.from === "Asset_Purchasing_Screen"
            ? "PurchScrollWidthNone"
            : "PurchScrollWidth"
        }
      >
        <div className="supplierDiv ms-4 me-5 mt-5 ps-4 py-3">
          <table className="table table-borderless">
            <thead>
              <tr className="">
                <th className="col purchSupplier ps-">Supplier</th>
                <th className="col pt-1 ps-5">
                  {locationSupplierName ||
                  (selectedSupplier && selectedSupplier.length > 0) ? (
                    <div className="d-flex gap-3 align-items-center justify-content-between">
                      <div
                        className="asc_CustomSelect pt-2"
                        onClick={() => setSupplierToggle(true)}
                      >
                        {selectedSupplier[0]?.suppliername
                          ? selectedSupplier[0]?.suppliername
                          : locationSupplierName}
                      </div>
                      <img
                        src={Xicon}
                        className={
                          selectedSupplier ? "purch_xicon pointer" : "invisible"
                        }
                        alt=""
                        onClick={() => {
                          setSelectedSupplier([]);
                          setSelectedSupplierData([]);
                          setLocationSupplierName("");
                          setLocationSupplierID("");
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      className="asc_CustomSelect pt-2 cursor-pointer"
                      onClick={() => setSupplierToggle(true)}
                    >
                      Select a supplier
                    </div>
                  )}
                </th>
                <th className=""></th>
                <th className="col purshProject ps-">Asset</th>
                <th className="col pt-1 ps-5">
                  <div className="asc_CustomSelect pt-2">
                    {parsedAsset?.assetName
                      ? parsedAsset?.assetName
                      : locationAssetName}
                  </div>
                </th>
                <th className="col"></th>
                <th className="col purchSendSupp text-end ps-">
                  Send by email to supplier?
                  {/* {FetchTranslationList?.data?.data[15]?.translation} */}
                </th>
                <th className="col">
                  <div className="ps-3">
                    <input
                      type="checkbox"
                      id="asc_purch_Switch"
                      className="asc_pursh_Checkbox"
                      checked={toggleActive}
                      onChange={(e) => {
                        // if (seewageRoleTabDisable) {
                        setToggleActive(!toggleActive);
                        //   setTypeField(!toggleActive);
                        // }
                        // setToggleActive(!toggleActive);
                        // setTypeField(e.target.value);
                      }}
                      // disabled={memberNonActiveAccess === false}
                    />
                    <label
                      htmlFor="asc_purch_Switch"
                      className="asc_purch_Toggle"
                    >
                      {/* <p className=''>ASC</p> */}
                    </label>
                  </div>
                </th>
                <th className="col"></th>
              </tr>
            </thead>
          </table>
        </div>

        <div className="supplierDiv px-4 mt-3 ms-4 me-5 py-3">
          <table className="table table-borderless m-0">
            <thead>
              <tr className="purchSupplierCode ps-">
                {/* {isBuildingBlock && (
                  <th className="col-2 column2 pb-4 ps-5"></th>
                )} */}
                <th className="col pb-4 ps-5">Supplier Code</th>
                <th className="col-4 pb-4 ps-5">Product Description</th>
                <th className="col pb-4 ps-5">Unit Price</th>
                <th className="col pb-4 ">Qty</th>
                <th className="col-2 pb-4 ps-4">Total</th>
                <th className="col pb-4 ps-0">Requested Deliver Days</th>
              </tr>
            </thead>
            {assetList.map((item, index) => {
              return (
                <>
                  <tbody className="horizontalBorderTop">
                    <tr className="text-center">
                      <td className="col-2 column2 text-start ps-5 py-4">
                        {item.internalId}
                      </td>
                      <td className="col-2 column2 documntName text-start ps-5 py-4">
                        {item.assetname}
                      </td>
                      <td className="documntName py-4">{item.costPrice}</td>
                      <td className="documntName py-4">
                        <input
                          className="purchSupplierCode"
                          type="number"
                          value={item.quantity}
                          onChange={(e) =>
                            handleQuantityChange(item.assetid, e.target.value)
                          }
                        />
                      </td>
                      <td className="documntName py-4">
                        {europeanFormatWithSymbol(item.total)}
                      </td>
                      <td className="documntName py-4">
                        <input
                          className="purchSupplierCode"
                          type="number"
                          value={item.requestedDeliverDays}
                          onChange={(e) =>
                            handleDaysChange(item.assetid, e.target.value)
                          }
                        />
                      </td>
                      <td className="documntName">
                        <img
                          className="cursor-pointer"
                          src={delete1}
                          alt="menu icon"
                          onClick={() => onDelete(index)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </>
              );
            })}
          </table>
          <div className="horizontalLine"></div>
          <table className="table table-borderless m-0">
            <thead>
              <tr>
                <th
                  className="col purchTypeItem py-4 ps-5"
                  onClick={() => setAssetToggle(true)}
                >
                  Select an asset
                </th>
              </tr>
            </thead>
          </table>
          <div className="horizontalLine"></div>

          <table className="table table-borderless ms-4">
            <thead>
              <tr>
                <th className="col-7"></th>
                <th className="col-3 purchTotal2 text-center py-4 ps-5">
                  TOTAL
                  {/* {FetchTranslationList?.data?.data[22]?.translation} */}
                </th>
                {/* <th className="col purchTotal2 py-4 ps-0"> {formattedCurrency(qty)} </th> */}
                <th className="col purchTotal2 py-4 ps-0">
                  {europeanFormatWithSymbol(
                    assetList.reduce((a, b) => (a = a + b.total), 0),
                  )}
                </th>
              </tr>
            </thead>
          </table>
        </div>
      </div>
      {supplierToggle && (
        <div className="asset-wrp">
          <div className="asset-title">Choose a supplier</div>
          <div className="add-part-lists">
            {supplier?.map((item) => (
              <div
                key={item.supplierid}
                className="d-flex py-1 align-items-center justify-content-between"
                style={{ borderTop: "1px dashed rgb(126, 126, 126)" }}
                onClick={() => {
                  setSelectedSupplierData(() => [item]);
                }}
              >
                <span className="product-compo-title">{item.suppliername}</span>
                <img
                  // onClick={() => {
                  //   setSelectedSupplierData(() => [item]);
                  // }}
                  className="plus-img me-1"
                  src={
                    Array.isArray(selectedSupplierData) &&
                    selectedSupplierData.includes(item)
                      ? CheckboxBlueIcon
                      : CheckboxIcon
                  }
                  alt="check-item"
                />
              </div>
            ))}
          </div>
          <div className="d-flex align-items-center justify-content-end">
            <button
              type="button"
              className="btn addParchCancel me-4"
              onClick={() => {
                setSupplierToggle(false);
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn addParchAdd "
              onClick={() => {
                if (selectedSupplierData[0].supplierid) {
                  setSelectedSupplier(selectedSupplierData);
                }
                setSupplierToggle(false);
              }}
            >
              Confirm
            </button>
          </div>
        </div>
      )}
      {assetToggle && (
        <EquipmentsPartsModal
          supplierId={selectedSupplier[0]?.supplierid ?? ""}
          locationSupplierID={locationSupplierID}
          modalOpen={assetToggle}
          modalHideEv={handleCancel}
          assetList={assetList}
          setAssetList={setAssetList}
        />
      )}
    </div>
  );
};

export default ViewPurchasingOrderAssets;
